import * as React from "react";

import { cn } from "@/lib/utils";

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      "text-xs font-semibold uppercase tracking-wide text-de-muted",
      className
    )}
    {...props}
  />
));
Label.displayName = "Label";

export { Label };
